export default __webpack_public_path__ + "static/media/Ballroll_00326.e0165b36.png";